import BaseAPI from '@/apis/base/baseApi';
import httpClient from '@/apis/base/httpclient';

class exploitdbExploitdbPocAPI extends BaseAPI {
	constructor() {
		super();
	}
	apiName = 'Business';
	controllerName = 'ExploitdbPoc';

	getContent(exploitId) {
		let request = {
			url: `${this.getAPIUrl()}/${exploitId}/content`
		};

		return httpClient.getAsync(request);
	}

	sync() {
		let request = {
			url: `${this.getAPIUrl()}/sync`
		};

		return httpClient.postAsync(request);
	}
}

export default new exploitdbExploitdbPocAPI();
